import moment from 'moment/moment'

export const formatTimeAgo = (date: string) => {
  const pastDate = moment(date)
  const currentDate = moment()
  const duration = moment.duration(currentDate.diff(pastDate))

  const daysDifference = duration.days()
  const hoursDifference = duration.hours()
  const minutesDifference = duration.minutes()

  let formattedDifference = ''

  if (daysDifference > 0) {
    formattedDifference += `${daysDifference}d `
  }

  if (hoursDifference > 0) {
    formattedDifference += `${hoursDifference}h `
  }

  if (daysDifference == 0 && minutesDifference > 0) {
    formattedDifference += `${minutesDifference}m`
  }

  if (minutesDifference === 0) {
    formattedDifference += 'less than a min'
  }

  return `${formattedDifference} ago`
}
